import { twMerge } from "tailwind-merge";
import { type BankName } from "@services/budget/types";
import { bankCardMetadata } from "../budgetConstants";

interface IShortenedIbanProps {
  iban: string;
  bankName?: BankName;
  className?: string;
}

export const ShortenedIban: React.FC<IShortenedIbanProps> = (props) => {
  const { iban, bankName, className } = props;

  const BankAccountIcon = bankCardMetadata[bankName ?? "Default"]?.iconSmall;

  return (
    <div className={twMerge("inline-flex h-fit items-center gap-3", className)}>
      {BankAccountIcon && <BankAccountIcon className="size-6" />}
      {iban.slice(0, 2) + "..." + iban.slice(-4)}
    </div>
  );
};
